import './CategoryItemList.css';
import { useState } from 'react';
import CategoryItem from '../CategoryItem/CategoryItem';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import IconButton from '../IconButton/IconButton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const CategoryItemList = ({ items, onDelete, onItemClick, onAdd, onRemove, getInCart }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [confirmItemId, setConfirmItemId] = useState(null);

  if (!items || items.length === 0) return <p>No items in this category.</p>;

  const getLocalizedValue = (value) => {
    if (typeof value === 'object' && value !== null && i18n.language in value) {
      return value[i18n.language];
    }
    return typeof value === 'string' ? value : '';
  };

  const confirmItem = items.find(i => i._id === confirmItemId);
  const confirmItemIsLastCategory = confirmItem?.categories?.length === 1;

  return (
    <>
      <ul className="category-item-list">
        {items.map(({ _id, name, description, image }) => (
          <li key={_id} onClick={() => onItemClick ? onItemClick(_id) : navigate(`/catalog/item/${_id}`)}>
            <CategoryItem
              name={getLocalizedValue(name)}
              description={getLocalizedValue(description)}
              image={image}
              inCart={getInCart ? getInCart(_id) : false}
              onAdd={onAdd ? () => onAdd({ _id, name: getLocalizedValue(name), image }) : undefined}
              onRemove={onRemove ? () => onRemove(_id) : undefined}
            />
            {onDelete && (
              <IconButton
                icon="delete"
                variant="danger"
                aria-label="Delete item"
                onClick={(e) => { e.stopPropagation(); setConfirmItemId(_id); }}
              />
            )}
          </li>
        ))}
      </ul>

      {confirmItemId && (
        <ConfirmModal
          title={confirmItemIsLastCategory
            ? `Delete "${getLocalizedValue(confirmItem?.name)}"?`
            : `Remove "${getLocalizedValue(confirmItem?.name)}" from this category?`}
          message={confirmItemIsLastCategory
            ? 'This will permanently delete the item. This cannot be undone.'
            : 'The item will be removed from this category but will remain in its other categories.'}
          confirmLabel={confirmItemIsLastCategory ? 'Delete' : 'Remove'}
          onConfirm={() => { onDelete(confirmItemId); setConfirmItemId(null); }}
          onCancel={() => setConfirmItemId(null)}
        />
      )}
    </>
  );
};

export default CategoryItemList;
